import {NgModule, NO_ERRORS_SCHEMA} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ModalModule} from 'ngx-bootstrap/modal';
import {JwtParserService} from '../../shared/services/jwt-parser.service';
import {AuthGuard} from '../../shared/services/auth.guard';
import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {ApiInterceptor} from '../../shared/services/interceptor/api.interceptor';
import {ModalService} from '../../shared/services/modal.service';
import {RegistrationRoutingModule} from './registration-routing.module';
import {SharedModule} from '../../shared/shared.module';
import {TooltipModalComponent} from '../../shared/components/tooltip-modal/tooltip-modal.component';
import {SubscribeFreshpassComponent} from './subscribe-freshpass/subscribe-freshpass.component';
import {RegisterLandingPageComponent} from './register-landing-page/register-landing-page.component';

@NgModule({
    declarations: [
        SubscribeFreshpassComponent,
        RegisterLandingPageComponent],
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        RegistrationRoutingModule,
        ModalModule.forRoot(),
        SharedModule,
    ],
    exports: [],
    providers: [JwtParserService, AuthGuard, TooltipModalComponent, {
        provide: HTTP_INTERCEPTORS,
        useClass: ApiInterceptor,
        multi: true
    },
        ModalService],
    schemas: [NO_ERRORS_SCHEMA]
})
export class RegistrationModule {
}
